import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {NationalParksComponent} from './components/national-parks/national-parks.component';
import {SerengetiComponent} from './components/serengeti/serengeti.component';
import {ArushaComponent} from './components/arusha/arusha.component';
import {LakeManyaraComponent} from './components/lake-manyara/lake-manyara.component';
import {TarangireComponent} from './components/tarangire/tarangire.component';
import {NgorongoroComponent} from './components/ngorongoro/ngorongoro.component';
import {OlduvaiGorgeComponent} from './components/olduvai-gorge/olduvai-gorge.component';
import {IraqwCultureCenterComponent} from './components/iraqw-culture-center/iraqw-culture-center.component';


const routes: Routes = [
    {
        path: '',
        component: NationalParksComponent,
        data: {
            metaBlob: {
                title: 'Tanzania National Park Interactive Map | Explore the Parks',
                description: `Kopa Tours customers visit parks across Tanzania! From endless plains of the Serengeti, to forests of Lake Manyara, there's plenty of ecosystems to explore.`,
                twitterImage: 'others/baobab-tree.jpg',
                level: '2',
                index: '4'
            }
        }
    },
    {
        path: 'serengeti',
        component: SerengetiComponent,
        data: {
            metaBlob: {
                title: 'Serengeti National Park | Serengeti Safari Tours',
                description: `The preeminent savannah ecosystem, the endless plains of the Serengeti, give you a prime chance to see the Big Five and fabled Wildebeest Migration.`,
                twitterImage: 'others/cheetah-and-cubs.jpg',
                level: '2',
                index: '4'
            }
        }
    },
    {
        path: 'lake-manyara',
        component: LakeManyaraComponent,
        data: {
            metaBlob: {
                title: 'Lake Manyara National Park | A Haven for Tree Climbing Lions',
                description: `This intimate park is a dream for bird watching and animals such as unique tree climbing lions- making Lake Manyara the best kept secret in Tanzania.`,
                twitterImage: '1920x800/manyara-landscape.jpg',
                level: '2',
                index: '4'
            }
        }
    },
    {
        path: 'tarangire',
        component: TarangireComponent,
        data: {
            metaBlob: {
                title: 'Tarangire National Park | An Elephant Sanctuary',
                description: `A Game reserve hosting an elephant sanctuary, as well as Baobab trees- a massive tree also referred to as the Tree of Life or mti wa baobab in Swahili.`,
                twitterImage: 'others/tarangire-river.jpg',
                level: '2',
                index: '4'
            }
        }
    },
    {
        path: 'ngorongoro',
        component: NgorongoroComponent,
        data: {
            metaBlob: {
                title: 'Ngorongoro Crater | Densely Populated Conservation Area',
                description: `Ngorongoro Crater hosts a multitude of animals and was once home to the Nilotic Maasai people. The crater is one of the few places on Earth where Black Rhino still roam.`,
                twitterImage: 'others/ngorongoro.jpg',
                level: '2',
                index: '4'
            }
        }
    },
    {
        path: 'olduvai-gorge',
        component: OlduvaiGorgeComponent,
        data: {
            metaBlob: {
                title: 'Olduvai Gorge | The Cradle of Humanity',
                description: `As home to important moments in human evolution, Olduvai (Oldupai) Gorge contains some of the first discovered hominids- Homo Habilis, Lucy, and the Laetoli Footprints.`,
                twitterImage: '900x455/olduvai-footprint.jpg',
                level: '2',
                index: '4'
            }
        }
    },
    {
        path: 'iraqw-culture-center',
        component: IraqwCultureCenterComponent,
        data: {
            metaBlob: {
                title: 'Iraqw Culture Center | A Tribal Tanzania Experience',
                description: `An immersive experience in a rich, native African culture. Here, you will learn about the Iraqw tribe religion, family customs, tribal dress, and handcrafting skills.`,
                twitterImage: 'others/iraqw-woman-beading.jpg',
                level: '2',
                index: '4'
            }
        }
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class NationalParksRoutingModule {
}
